module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/rec-9-70a0a8dd404555b3fc7892d26f7b263a.jpg";